import AboutModal from './AboutModal'
import CategoriesModal from './CategoriesModal'
import CustomModels from './CustomModels'
import EducationModal from './EducationModal'
import ModelTiles from './ModelTiles'
import SoftwaresModal from './SoftwaresModal'
import WorkplaceModal from './WorkplaceModal'
import CoverPicture from '../../shared/CoverPicture'

export default {
    AboutModal,
    CategoriesModal,
    CustomModels,
    EducationModal,
    ModelTiles,
    SoftwaresModal,
    WorkplaceModal,
    CoverPicture
}